export enum PayMethods {
  PayPal = 'paypal',
  AliPay = 'alipay',
}

export const PayMethodText = {
  [PayMethods.PayPal]: 'PayPal',
  [PayMethods.AliPay]: 'pay.method.for_alipay',
};
